<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('association.Web_and_email_info') }}</h5>
    <p class="mb-0 text-sm">{{ $t('association.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-4">
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.Email') }}</label>
            <input v-model="localFormData.email" type="email" class="form-control form-control-default" :placeholder="$t('association.Email')">
            <span v-if="v$.email.$error" class="text-sm text-danger">
              {{ v$.email.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.WebsiteURL') }}</label>
            <input v-model="localFormData.websiteURL" type="text" class="form-control form-control-default" :placeholder="$t('association.WebsiteURL')">            
          </div>
        </div>
      </div>
    </div>
    <div class="button-row d-flex mt-4">
      <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">Prev</button>
      <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">Next</button>        
    </div>
  </div>
</template>

<script>
  import { computed, reactive, watch } from 'vue'
  import { email as emailValidator, helpers } from '@vuelidate/validators'
  import useVuelidate from '@vuelidate/core'
  import { useI18n } from 'vue-i18n'

export default {
  name: "WebEmailInfoSection",
  props: {
    formData: Object,
    nextStep: Function
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const localFormData = reactive({ ...props.formData })

    const rules = computed(() => ({
      email: {
        validFormat: helpers.withMessage(
          t('common.Invalid_email_address'),
          value => !value || emailValidator.$validator(value)
        )
      }
    }))

    const v$ = useVuelidate(rules, localFormData)

    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {      
      v$.value.$touch()
      const isValid = await v$.value.$validate();

      if (isValid) {
        props.nextStep();
      }
    }

    return {
      localFormData,
      v$,
      validateAndNextStep
    }
  }
};
</script>